import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import toastr from "toastr";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  // fieldValue is column value
  // row is whole row object
  // rowIdx is index of row
  // colIdx is index of column
  if (row.empStatus == 'F')
    return 'blue';

  return row.empStatus == 'I' ? 'color3' : 'td-column-function-odd-example';
}

function columnClassNameVerticalHeadFormat(fieldValue, row, rowIdx, colIdx){
  return row.vhStatus == 'pending' ? 'color2' : 'color4';
}

function columnClassNameStatusFormat(fieldValue, row, rowIdx, colIdx) {
  return row.adminStatus == 'pending' ? 'color2' : 'color4';
}
function enumFormatter(cell, row, enumObject) {
  return enumObject[cell];
}
class ExitTable extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {
    const payrollType = {
      'Quikr': 'Quikr',
      'Team Lease': 'Team Lease'
    };
    const statusType = {
      'R': 'R',
      'I': 'I'
    };
    const toeType = {
      'Involuntary': 'Involuntary',
      'Voluntary': 'Voluntary'
    }
    const noeType = {
      'Serving': 'Serving',
      'Waived_Off': 'Waived Off',
      'Gardening': 'Gardening'
    }
    const runningStatusType = {
      'pending': 'Pending',
      'Completed': 'Completed'

    }

    const options = {
      clearSearch: true,

      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    return (
      <div>
        <BootstrapTable
          exportCSV={true}
          headerStyle={ {border: 'grey 1px solid', size: '10px'} }


          containerStyle={{paddingTop: 0}}
          data={this.props.employees}
          search={true}
          striped
          options={options}
          pagination>
          <TableHead

            isKey={false}
            hidden={false}
            columnClassName={ columnClassNameFormat }
            width={50}
            dataFormat={(cell, row)=> {
              return <div>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                  <img
                    style={{cursor: 'pointer'}}
                    onClick={()=> {
                      if (row.empStatus == "I" && row.adminStatus.substr(0, 9) == 'completed') {
                        toastr.info("Employee is inactive");
                        return;
                      }
                      this.props.edit(row);
                      this.props.open();
                    }
                    }
                    src="/public/images/edit.png"></img>
                </OverlayTrigger>
                <hr style={{padding: 1, margin: 1}}/>

              </div>
            }}
            dataField="empId"> </TableHead>
          <TableHead dataSort={true}
                     isKey={true}
                     hidden={false}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Id'} }
                     width={100}
                     columnClassName={ columnClassNameFormat }
                     dataField="employeeCode">Id</TableHead>
          <TableHead dataSort={true}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell, row)=> {
                       if (row.typeOfExit == 'abscond')
                         return <font>{cell}&nbsp;(*abscond)</font>
                       else
                         return <font>{cell}</font>
                     }}
                     width={140} dataField="name"
          >Name</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'EmailId'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="emailId">Email Id</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameVerticalHeadFormat }
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'VH Status'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="vhStatus">VH Status</TableHead>
          <TableHead dataField="adminStatus"
                     width={160}
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'Facilities Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameStatusFormat }
          >Facilities Status</TableHead>
          <TableHead dataField="doLeaving"

                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != " " && cell != 0)
                         return <font>{new Date(cell).toLocaleDateString('en-GB')}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={200}>Last Working Day</TableHead>


          <TableHead dataField="location"
                     filter={ {type: 'SelectFilter', options: this.props.constants.locationFilter, placeholder: 'Location'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={120}>Location</TableHead>

        </BootstrapTable>

      </div>
    );
  }
}

ExitTable.propTypes = {};

export default ExitTable;





/** WEBPACK FOOTER **
 ** ./src/feature/admin/Exit/AdminExitTable.js
 **/